/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Mifflin-St Jeor equation, which is more accurate for most people than the older Harris-Benedict formula.`)
};

const es_bmr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ecuación de Mifflin-St Jeor, que es más precisa para la mayoría de las personas que la antigua fórmula de Harris-Benedict.`)
};

const de_bmr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Mifflin-St-Jeor-Formel, die für die meisten Menschen genauer ist als die ältere Harris-Benedict-Formel.`)
};

const nl_bmr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De Mifflin-St Jeor-formule, die voor de meeste mensen nauwkeuriger is dan de oudere Harris-Benedict-formule.`)
};

const fr_bmr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'équation de Mifflin-St Jeor, plus précise pour la plupart des gens que l'ancienne formule de Harris-Benedict.`)
};

const it_bmr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'equazione di Mifflin-St Jeor, più accurata per la maggior parte delle persone rispetto alla più datata formula di Harris-Benedict.`)
};

const pt_br2_bmr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A equação de Mifflin-St Jeor, que é mais precisa para a maioria das pessoas do que a fórmula mais antiga de Harris-Benedict.`)
};

const pt_bmr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A equação de Mifflin-St Jeor, mais precisa para a maioria das pessoas do que a fórmula mais antiga de Harris-Benedict.`)
};

const ja_bmr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミフリン・セントジオール方程式が使われています。これは従来のハリス・ベネディクト方程式よりも多くの人にとって正確とされています。`)
};

const zh_bmr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mifflin-St Jeor 公式，相较于较早的 Harris-Benedict 公式，它对大多数人更为准确。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_faq_a3", locale)
	if (locale === "en") return en_bmr_faq_a3(inputs)
	if (locale === "es") return es_bmr_faq_a3(inputs)
	if (locale === "de") return de_bmr_faq_a3(inputs)
	if (locale === "nl") return nl_bmr_faq_a3(inputs)
	if (locale === "fr") return fr_bmr_faq_a3(inputs)
	if (locale === "it") return it_bmr_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_faq_a3(inputs)
	if (locale === "pt") return pt_bmr_faq_a3(inputs)
	if (locale === "ja") return ja_bmr_faq_a3(inputs)
	return zh_bmr_faq_a3(inputs)
};